// assets
import { HomeOutlined } from '@ant-design/icons';
import { ProjectOutlined, FileOutlined } from '@ant-design/icons';
// icons
const icons = {
  HomeOutlined,
  ProjectOutlined,
  FileOutlined
};

// ==============================|| MENU ITEMS - HOME ||============================== //

const home = {
  id: 'home-dashboard',
  title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'home',
      title: 'Home',
      type: 'item',
      url: '/',
      icon: icons.HomeOutlined,
      breadcrumbs: false
    },
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.ProjectOutlined,
      breadcrumbs: false
    },
    {
      id: 'viewdata',
      title: 'Maintenance Reminder',
      type: 'item',
      url: '/maintenance-reminder',
      icon: icons.FileOutlined,
      breadcrumbs: false
    },
    {
      id: 'cesiummap',
      title: '3D Map',
      type: 'item',
      url: '/3d-map',
      icon: icons.ProjectOutlined,
      breadcrumbs: false
    }
  ]
};

export default home;
